﻿import type { IKanbanLoadTracker } from '../types/modules/kanban';

const kanbanLoadTracker: IKanbanLoadTracker = {};

function firstLoadKanban(id: string, callback: () => void) {
    if (!kanbanLoadTracker[id]) {
        callback();
        kanbanLoadTracker[id] = true;
    }
}

function refreshKanbanOnVisible(kanbanId = '#kanbanView') {
    if ($(kanbanId).is(':visible')) {
        window.refreshKanban();
    }
}

function toggleGridKanbanPanel({ sender }: { sender: kendo.ui.Button }) {
    const kanbanId: string = '#kanbanView';
    const gridView = $('#gridView');
    const kanbanView = $(kanbanId);
    const toggleButton = sender.element;
    const kendoGrid = $('[data-role=grid]').data('kendoGrid');
    const localeDict = window.getLocaleDict().button;

    if (gridView.is(':visible')) {
        gridView.hide();
        window.firstLoadKanban(kanbanId, window.refreshKanban);
        kanbanView.show();
        toggleButton.text(localeDict.showGrid);
    }
    else {
        gridView.show();
        if (kendoGrid?.dataItems().length) {
            window.rebindDataSource(kendoGrid);
        }
        kanbanView.hide();
        toggleButton.text(localeDict.showKanban);
    }
}

window.toggleGridKanbanPanel = toggleGridKanbanPanel;
window.firstLoadKanban = firstLoadKanban;
window.refreshKanbanOnVisible = refreshKanbanOnVisible;
